import React, { FunctionComponent } from 'react';
import binoculars from '../../assets/images/binoculars-bear.svg';
import ipad from '../../assets/images/ipad-bear.svg';
import fisher from '../../assets/images/fisher-bear.svg';
import map from '../../assets/images/map-bear.svg';
import sitting from '../../assets/images/sitting-bear.svg';
import styles from './styles.module.scss';
import ImageWrapper from '../ImageWrapper';

interface IIllustrationProps {
  variant: 'binoculars' | 'ipad' | 'fisher' | 'map' | 'sitting';
  header?: JSX.Element | string;
  description?: JSX.Element | string;
  button?: JSX.Element;
  height?: string;
  width?: string;
}

const Illustration: FunctionComponent<IIllustrationProps> = ({
  variant,
  header,
  description,
  button,
  height = 'auto',
  width = 'auto'
}) => {
  const illustrations = {
    binoculars,
    ipad,
    fisher,
    map,
    sitting
  };

  return (
    <div className="d-flex justify-content-center">
      <div
        className={`d-flex flex-column justify-content-center align-items-center ${styles.illustration} illustration`}
      >
        <ImageWrapper src={illustrations[variant]} height={height} width={width} />
        {header ? (<p className={`${styles.header} t-18`}>{header}</p>) : null}
        {description ? (<p className={`${styles.description} t-12`}>{description}</p>) : null}
        {button || null}
      </div>
    </div>
  );
};

export default Illustration;
